import React from 'react';
import ReactDOM from 'react-dom';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

const hydratePageComponent = (PageComponent) => {
  const emotionCache = createCache({ key: 'brc' });

  ReactDOM.hydrate(
    <CacheProvider value={emotionCache}>
      <PageComponent {...modelData} />
    </CacheProvider>,
    document.querySelector('#document-body'),
  );
};

export { hydratePageComponent };
